import { useDependenciesForCreateExpenseQuery } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { useStore } from "../store";

export const useFetchDependencies = (): boolean => {
  const store = useStore();

  const { loading, refetch } = useDependenciesForCreateExpenseQuery({
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      store.setDependencies(data);
    },
    ...onError(),
  });

  store.refetchDependencies = refetch;

  return loading;
};
